import { Component, Input } from '@angular/core';
import { ResponsiveService } from '../../services/responsive.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-number-with-description',
  imports: [CommonModule],
  templateUrl: './number-with-description.html',
  styleUrl: './number-with-description.scss',
})
export class NumberWithDescription {
  isMobile: boolean = false;

	@Input() number = 0;
	@Input() total : any;
	@Input() description: string = '';
	@Input() flex: boolean = false;

	constructor(private responsiveService: ResponsiveService) {	}

	ngOnInit(){
		this.onResize();
		this.responsiveService.checkWidth();
	}

	
	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	  }
}
